module.exports = __webpack_public_path__ + "static/media/users.7cbf0a2a.png";